import { EventAction } from 'utils/analytics/amplitudeEventConstants';
import { PartyState } from 'types/service';
import { TableStatus } from 'selectors/tableOccupancySelector';
import { amplitudeSendEvent } from 'utils/analytics/amplitude';

export type AssignmentStatus = TableStatus | 'added' | 'removed' | 'multiple';
type AssignmentLocation = 'timeline' | 'service';

export const trackAssignmentCancelled = (location: AssignmentLocation) => {
  const actionLocation = getActionLocationFromAssignmentLocation(location);

  amplitudeSendEvent(EventAction.CANCEL_TABLE_ASSIGNMENT, {
    actionLocation,
  });
};

export const trackAssignmentCompleted = (
  location: AssignmentLocation,
  partyState: PartyState,
  tableStatus?: AssignmentStatus
) => {
  const expectedStates: PartyState[] = [
    'ARRIVED',
    'PARTIALLY_ARRIVED',
    'PARTIALLY_SEATED',
    'EXPECTED',
  ];
  const prettyState = expectedStates.includes(partyState)
    ? 'expected'
    : partyState.toLowerCase().replace('_', '-');
  const label = tableStatus
    ? `${prettyState}-party.${tableStatus.toLowerCase()}-table`
    : `${prettyState}-party`;

  const actionLocation = getActionLocationFromAssignmentLocation(location);

  amplitudeSendEvent(EventAction.PARTY_TABLE_ASSIGNMENT_DISMISSED, {
    tableAssignmentLabel: `${location}.${label}`,
    actionLocation,
  });
};

const getActionLocationFromAssignmentLocation = (location: AssignmentLocation) => {
  switch (location) {
    case 'service':
      return 'Service body';
    case 'timeline':
      return 'Timeline body';
  }
};
